import { shallowRef, type Component } from 'vue';

interface ComponentContext {
  component?: Component;
  props?: Record<string, any>;
  hide?: boolean; // can be used to hide the component conditionally, e.g. based on user permissions or feature flags
}
const componentContext = shallowRef<ComponentContext[]>([]);

const setComponentContext = (context: ComponentContext[]) => {
  componentContext.value = context.map((component) => ({
    ...component,
    props: component.props ?? {},
  }));
};

const resetComponentContext = () => {
  componentContext.value = [];
};

export function useHeaderComponentContext() {
  return {
    componentContext,
    setComponentContext,
    resetComponentContext,
  };
}
